import { render, staticRenderFns } from "./lgScreenSet.vue?vue&type=template&id=7297b778"
import script from "./lgScreenSet.vue?vue&type=script&lang=js"
export * from "./lgScreenSet.vue?vue&type=script&lang=js"
import style0 from "./lgScreenSet.vue?vue&type=style&index=0&id=7297b778&prod&lang=less"
import style1 from "./lgScreenSet.vue?vue&type=style&index=1&id=7297b778&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports